var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgLoadSafe = function SvgLoadSafe(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0H18V4H6V0Z",
    fill: "url(#paint0_linear_1_66)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13L16 1L20 1V13H16Z",
    fill: "url(#paint1_linear_1_66)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.960938 15.5244L14.4853 2.00007L17.3137 4.8285L3.78936 18.3528L0.960938 15.5244Z",
    fill: "url(#paint2_linear_1_66)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_66",
    x1: 7.97533,
    y1: 11.5913,
    x2: 12.8018,
    y2: 6.58436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AAEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_66",
    x1: 7.97533,
    y1: 11.5913,
    x2: 12.8018,
    y2: 6.58436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AAEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_66",
    x1: 7.97533,
    y1: 11.5913,
    x2: 12.8018,
    y2: 6.58436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AAEFF"
  })))));
};
export default SvgLoadSafe;